module.exports = __webpack_public_path__ + "img/screen-capture.2bdaf141.webp";